import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18N_PROVIDERS } from './config';
import { I18NextModule, I18NextPipe } from 'angular-i18next';

@NgModule({
  imports: [
    CommonModule,
    // Third Party
    I18NextModule.forRoot(),
  ],
  exports: [I18NextPipe],
  providers: [I18N_PROVIDERS],
})
export class I18nModule {}
